import { IUnit } from '../interfaces/unit';
import * as baseAdapter from './baseAdapter';

export const queryUnits = async () => {
  const ret = await baseAdapter.get<IUnit[]>('/unit');
  return ret;
};

export const addUnit = async (data: IUnit) => {
  const ret = await baseAdapter.post<IUnit>('/unit', data);
  return ret;
};

export const editUnit = async (data: IUnit) => {
  const ret = await baseAdapter.put(`/unit/${data.name}`, data);
  return ret;
};

export const deleteUnit = async (id: string) => {
  const ret = await baseAdapter.deleteRequest(`/unit/${id}`);
  return ret;
};
